(function() {
  var ParentDialogHandler,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ParentDialogHandler = App.loadClass('portal::handlers/convert/Parent_Dialog_Handler');

  exports.Convert_Dialog_Handler = (function(superClass) {
    extend(Convert_Dialog_Handler, superClass);

    function Convert_Dialog_Handler() {
      return Convert_Dialog_Handler.__super__.constructor.apply(this, arguments);
    }

    Convert_Dialog_Handler.prototype.init = function() {
      this.reportAjax = 'backend/portal/convert/get-data';
      this.layoutUrl = 'backend/portal/convert/load-layout-dialog';
      this.exportUrl = 'backend/portal/convert/export';
      this.saveUrl = 'backend/portal/convert/save-contracts';
      return Convert_Dialog_Handler.__super__.init.call(this);
    };


    /*
    Datatables fnRowCallback used to build the datatable report
     */

    Convert_Dialog_Handler.prototype.rowCallback = function(row, data) {
      $(row).addClass('plan-row tr-no-bottom-margin');
      $('td:eq(0)', row).html("<input type='checkbox' name='autofill' class='chk-copy'>");
      $('td:eq(1)', row).html("<span class='labels-vertical-pad'>" + data[1] + "</span>");
      $('td:eq(2)', row).html("<span class='labels-vertical-pad' title='" + data[2] + "'>" + data[2] + "</span>");
      $('td:eq(2)', row).addClass('convert-field-name');
      $('td:eq(3)', row).html("<input type='text' name='plan_acres' disabled='disabled' class='input-mini txt-plan-acres ' value='" + data[3] + "'></input>");
      $('td:eq(3)', row).addClass('normal-line');
      $('td:eq(4)', row).html("<input type='text' name='plan_brand' disabled='disabled' class='input-mini' value='" + data[4] + "'></input>");
      $('td:eq(5)', row).html("<input type='text' name='plan_pop' disabled='disabled' class='input-mini txt-plan-pop ' value='" + data[5] + "'></input>");
      $('td:eq(6)', row).html("<input type='text' name='plan_pot' disabled='disabled' class='input-mini txt-plan-yield ' value='" + data[6] + "'></input>");
      $('td:eq(7)', row).html("<div class='crazy-arrow-line td-version'></div><div class='copy-btn btn btn-primary'><i class='fa fa-arrow-right'></i></div>");
      $('td:eq(8)', row).html("<input type='text' name='actual_acres' class='input-mini txt-actual-acres ' data-orig='" + data[8] + "' value='" + data[8] + "'></input>");
      $('td:eq(9)', row).html("<input type='text' name='actual_pop' class='input-mini txt-actual-pop ' data-orig='" + data[9] + "' value='" + data[9] + "'></input>");
      $('td:eq(10)', row).html("<input type='text' name='actual_date' class='input-mini txt-actual-date ' data-orig='" + data[10] + "' value='" + data[10] + "'></input>");
      $('td:eq(10)', row).find('.txt-actual-date').datepicker();
      $('td:eq(11)', row).html("<div class='input-append'><input type='text' name='actual_percent' class='txt-actual-percent input-mini' data-orig='" + data[11] + "' value='" + data[11] + "'><div class='add-on'> % </div></div>");
      return $('td:eq(12)', row).html("<input type='text' name='actual_est' disabled='disabled' class='input-mini txt-actual-yield ' data-orig='" + data[12] + "' value='" + data[12] + "'></input>");
    };

    Convert_Dialog_Handler.prototype.saveStub = function() {
      var acres, date, doSave, elem, fcid, i, j, len, len1, percent, pop, ref, ref1, row;
      this.dialog.find('.errorDiv').hide();
      this.dialog.find('.mfvalidate-invalid').removeClass('mfvalidate-invalid');
      doSave = true;
      this.saveData['toDelete'] = [];
      this.saveData['toAdd'] = [];
      ref = this.dialog.find('.plan-row');
      for (i = 0, len = ref.length; i < len; i++) {
        row = ref[i];
        row = $(row);
        fcid = row.attr('id');
        acres = row.find('.txt-actual-acres').val();
        pop = row.find('.txt-actual-pop').val();
        date = row.find('.txt-actual-date').val();
        percent = row.find('.txt-actual-percent').val();
        if (!acres && !pop && !date && !percent) {
          this.saveData['toDelete'].push(fcid);
        } else if (acres && pop && date && percent) {
          if (!Date.parse(date) || !date.match(/^\d+\/\d+\/\d+$/)) {
            row.find('.txt-actual-date').addClass('mfvalidate-invalid');
            doSave = false;
          } else {
            this.saveData['toAdd'].push({
              fc_id: fcid,
              acres: acres,
              pop: pop,
              date: date,
              percent: percent
            });
          }
        } else {
          if (!acres) {
            row.find('.txt-actual-acres').addClass('mfvalidate-invalid');
          }
          if (!pop) {
            row.find('.txt-actual-pop').addClass('mfvalidate-invalid');
          }
          if (!date) {
            row.find('.txt-actual-date').addClass('mfvalidate-invalid');
          }
          if (!percent) {
            row.find('.txt-actual-percent').addClass('mfvalidate-invalid');
          }
          doSave = false;
        }
      }
      if (doSave) {
        ref1 = this.dialog.find('[data-orig]');
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          elem = ref1[j];
          $(elem).data('orig', $(elem).val());
        }
        this.saveData['toDelete'] = JSON.stringify(this.saveData['toDelete']);
        this.saveData['toAdd'] = JSON.stringify(this.saveData['toAdd']);
        return this.save('Saving Planting Records');
      } else {
        return this.dialog.find('.errorDiv').html('There were errors saving your data. Please correct the highlighted values and try again.').show();
      }
    };

    return Convert_Dialog_Handler;

  })(ParentDialogHandler);

}).call(this);
